import style from './logo-recruitment.scss';
import inView from 'in-view';
import $ from "jquery";
import {animatedDigits} from "Assets/js/animated-digits";
import timing from "DesignSystem/motion/timing";
import staticSizes from './../../../design-system/layout/static-sizes';

const script = () => {
  const cssClass: string = 'LogoRecruitment';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    inView.offset(staticSizes.params['in-view'].offset.mobile);
    inView(`.${cssClass}`)
      .once('enter', ()=>{
        elt.classList.add('isInViewport');
      });
  }
};

export {
  style,
  script,
};
